module.exports = __webpack_public_path__ + "static/media/msm_logo.63492a10.svg";